import { FunctionComponent, memo } from "react";
import { IProps } from "./phrase-triggers-performance-chart-filters.types";
import { Form, Formik } from "formik";
import { SubmitOnChange } from "@edgetier/components";
import { DateFilter } from "@edgetier/date-filter";
import { trackUser } from "utilities/track-user";
import "./phrase-triggers-performance-chart-filters.scss";

/**
 * Performance chart filters, displaying chart date range
 * @param props.initialValues
 * @param props.onSubmit
 */
const PhraseTriggersPerformanceChartFilters: FunctionComponent<IProps> = ({ initialValues, onSubmit }) => {
    return (
        <Formik initialValues={initialValues} onSubmit={onSubmit}>
            <Form
                name="phrase-triggers-performance-chart-filters"
                className="phrase-triggers-performance-chart-filters"
            >
                <DateFilter
                    allowTimeSelect
                    showResetButton={false}
                    startDateName="startDateTime"
                    endDateName="endDateTime"
                    limitSelectionMonths={1}
                    onChange={() => {
                        trackUser("Select Date Range");
                    }}
                />

                <SubmitOnChange />
            </Form>
        </Formik>
    );
};

export default memo(PhraseTriggersPerformanceChartFilters);
